import { globalStore } from '@app/model/store'
import { addTemporaryNotice } from '@widgets/Common/Notices'
import { BasePropsParameters } from '@shared/api/types/apiPublicParameters'

type TypeApiKey = keyof typeof textErrorsApiPublic | keyof typeof textErrorsApiOwner
type TypeParamsProps = {
  isShowToUser?: boolean
  textError?: string
  isThrowException?: boolean
}

/**
 * @function middlewareError
 * @description isThrowException - для данного метода отключена до рефакторинга аутентификации
 *    сейчас ошибка срабатывает постоянно, на деле должна выскакивать,
 *    только если действительно существует проблема,
 *    сейчас же мы просто неверно выполняем запрос:
 *    пытаемся запросить данные о пользователе, которого еще нет
 */
export const middlewareError = (
  apiKey: TypeApiKey,
  paramsProps?: Partial<Pick<BasePropsParameters, 'error'>>,
  paramsImportant?: TypeParamsProps,
) => {
  const textError =
    paramsProps?.error?.text || textErrorsApiPublic[apiKey] || textErrorsApiOwner[apiKey] || 'Произошла ошибка'

  const resultParams = {
    isShowToUser: paramsProps?.error?.showUser || false,
    textError: textError,
    isThrowException: true,
    ...paramsImportant,
  }

  if (!globalStore?.dispatch) {
    console.error('Global store or dispatch is not available')
    return
  }

  const dispatch = globalStore.dispatch

  resultParams.isShowToUser && dispatch(addTemporaryNotice({ markup: resultParams.textError }))
  console.error(textError)

  if (resultParams.isThrowException) {
    throw new Error(textError)
  }
}

/**
 * @constant textErrorsApiPublic
 */
export const textErrorsApiPublic = {
  assistant_list: 'Ошибка загрузки списка сообщений ассистента',
  assistant_create: 'Ошибка отправки сообщения ассистенту',
  booking_create: 'Ошибка отправки данных',
  booking_get_slots: 'Ошибка загрузки слотов онлайн-бронирования',
  booking_discount: 'Не удалось проверить скидку, попробуйте позже',
  booking_restaurants_list: 'Ошибка загрузки списков ресторанов с бронированием',
  city_list: 'Ошибка загрузки списка городов',
  city_read: 'Ошибка загрузки данных о городе',
  metro_list: 'Ошибка загрузки списка метро',
  news_list: 'Ошибка загрузки списка новостей',
  news_read: 'Ошибка загрузки новости',
  photo_list: 'Ошибка загрузки галереи',
  restaurant_list: 'Ошибка загрузки списка ресторанов',
  restaurant_read: 'Ошибка загрузки данных о ресторане',
  restaurant_nearest_rests: 'Ошибка загрузки списка ближайших ресторанов',
  restaurant_popular_rests: 'Ошибка загрузки списка популярных ресторанов',
  restaurant_similar_rests: 'Ошибка загрузки списка похожих ресторанов',
  restorator: 'Ошибка отправки данных',
  restorator_organization: 'Ошибка отправки данных',
  restorator_promotion: 'Ошибка отправки данных',
  reviews_list: 'Ошибка загрузки отзывов',
  reviews_create: 'Ошибка отправки отзыва',
  reviews_partial_update: 'Ошибка отправки обновленного отзыва',
  reviews_update: 'Ошибка отправки обновленного отзыва',
  reviews_delete: 'Ошибка отправки удаления отзыва',
  selection_list: 'Ошибка загрузки списка подборок',
  selection_read: 'Ошибка загрузки данных о подборке',
  selection_restaurants: 'Ошибка загрузки списка ресторанов подборки',
  seo_read: 'Ошибка загрузки данных сео',
  tag_list: 'Ошибка загрузки тегов',
  user_logout: 'Ошибка попытки выхода из личного кабинета',
  user_me: 'Ошибка получения данных о пользователе',
  variety_list: 'Ошибка загрузки фильтров',
  video_list: 'Ошибка загрузки видео',
  send_mistake: 'Что-то пошло не так. Форма не отправлена.\n' + 'Попробуйте позже еще раз.',
  send_new_rest: 'Что-то пошло не так. Форма не отправлена.\n' + 'Попробуйте позже еще раз.',
  change_favorite: 'Что-то пошло не так, попробуйте позже',
} as const

/**
 * @constant textErrorsApiOwner
 */
export const textErrorsApiOwner = {
  api_files_list: 'Ошибка получения списка файлов',
  api_files_create: 'Ошибка создания файла',
  api_files_read: 'Ошибка чтения файлов',
  api_files_delete: 'Ошибка удаления файлов',
  r_read: 'Ошибка чтения ресторана',
  r_read_stat: 'Ошибка чтения статистики',
  r_info: 'Ошибка получения информации о ресторане',
  r_menu_partial_update: 'Ошибка обновления меню',
  r_menu_item_create: 'Ошибка создания элемента меню',
  r_menu_item_partial_update: 'Ошибка обновления элемента меню',
  r_menu_item_delete: 'Ошибка удаления элемента меню',
  r_news_partial_update: 'Ошибка обновления материала: новость',
  r_special_partial_update: 'Ошибка обновления материала: спецпредложение',
  owner_reviews_list: 'Ошибка получения списка отзывов',
  owner_reviews_read: 'Ошибка получения отзыва',
  owner_reviews_partial_update: 'Ошибка обновления отзыва',
} as const
